__webpack_require__.p = "/welcome-video-update/account-setup/";